module.exports = __webpack_public_path__ + "img/logo__dark.389fa96c.svg";